<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    offset-y
    min-width="290"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="displayText"
        :label="label"
        :placeholder="placeholder"
        prepend-inner-icon="mdi-calendar"
        readonly
        outlined
        dense
        hide-details
        clearable
        v-bind="attrs"
        v-on="on"
        @click:clear="clearRange"
      />
    </template>
    <v-date-picker v-model="range" range no-title>
      <v-spacer />
      <v-btn text small @click="clearRange">{{
        $t("reports.aiCredit.clear")
      }}</v-btn>
      <v-btn
        color="primary"
        small
        depressed
        :disabled="range.length < 1"
        @click="apply"
      >
        {{ $t("reports.aiCredit.apply") }}
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
/**
 * Compact date-range picker field. v-model is [from, to] (ISO date strings) or
 * an empty array. Emits `input` on Apply / Clear.
 */
export default {
  name: "DateRangeField",
  props: {
    value: { type: Array, default: () => [] },
    label: { type: String, default: "" },
    placeholder: { type: String, default: "" },
  },
  data() {
    return {
      menu: false,
      range: Array.isArray(this.value) ? [...this.value] : [],
    };
  },
  computed: {
    displayText() {
      if (!this.value || !this.value.length) return "";
      const [a, b] = this.value;
      return b ? `${a} ~ ${b}` : a;
    },
  },
  watch: {
    value(v) {
      this.range = Array.isArray(v) ? [...v] : [];
    },
  },
  methods: {
    apply() {
      const sorted = [...this.range].sort();
      this.$emit("input", sorted);
      this.menu = false;
    },
    clearRange() {
      this.range = [];
      this.$emit("input", []);
      this.menu = false;
    },
  },
};
</script>
